import { PdfReportGenerator } from '@/providers/PdfReportGenerator';

export default {
  data: function () {
    return {
      isWithReport: false,
      reportsLoading: false,
    };
  },
  methods: {
    onGenerateReport: function () {
      this.isWithReport = true;
      this.reportsLoading = true;
    },
    onReportReady: function () {
      setTimeout(async () => {
        try {
          if (
            !this.$refs.reportMarkdownCharts ||
            !this.isWithReport
          ) {
            this.reportsLoading = false;
            return;
          }
          const report = new PdfReportGenerator(
            this.$refs.reportMarkdownCharts,
            this.$refs.reportMarkdownChartsFooter
          );
          await report.populateWithDataAndSave('report.pdf');
        } catch (e) {
          process.env.NODE_ENV !== 'production' && console.error(e);
          this.$toasted.error('Error during report generation', {
            duration: 3000,
          });
        } finally {
          this.isWithReport = false;
          this.reportsLoading = false;
        }
      }, 1500);
    },
  },
};
